export const REQUIRED_FIELD = 'This field is required.';
export const ERROR_OCCURED = 'An error occured, Please try again.';
export const MESSAGES = {
    FunctionNotImplemented: "Function not implemented.",
    MessageDialogDelete:(item:string)=>`Are you sure you want to delete the item titled "${item}"? This action cannot be undone.`,
    MessageMarkScriptHas: "Are you sure you want to mark this script as",
    MessageActionWillUpdateScriptStatus: " This action will update the script's status.",
    MessageUploadScript: "Please upload a script",
    MessageSucessFully: "Successfully saved",
    MessageUpdateSucessFully: "Successfully Updated",
    MessageSucessFullyConfigFile: "Config File Successfully Added",
    MessageSucessFullyRemoved: "Successfully removed.",
    MessagemDecommission:"The decommissioning process has been initiated.",
    MessageConfirmThis: "Are you sure you want to confirm this?",
    MessageConfirmDelete: "Are you sure you want to delete this?",
    ErrorDelectingScript:"Error deleting script:",
    MessageDecommission:"Decommissioning process is about to begin. Do you wish to proceed?",
    ErrorDecommission:"Error trying to initialize decommission",
    ErrorDecommissionIdMissing:"Item ID is missing. Cannot proceed with decommissioning.",
    MessageErrorSavingScript:"Error saving script",
    MessageErrorSavingCloudEnviroment:"Error saving Cloud Environment ",
    MessageErrorUpdatingCloudEnviroment:"Error Updating Cloud Environment ",
    MessageErrorSavingScriptConfigFile:"Error Adding Config File:",
    /** Required */
    MessageCloudProviderRequired: "Cloud Provider is required",
    MessageDescriptionRequired: "Description is required",
    MessageTitleRequired:"Title is Required",
    MessageSearchRequired:"Search is Required"

}
